module.exports = __webpack_public_path__ + "img/questionnaireBanner.c6dc9d66.png";